"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoSchema = void 0;
var LogoSchema;
(function (LogoSchema) {
    LogoSchema["Color"] = "color";
    LogoSchema["White"] = "white";
    LogoSchema["Black"] = "black";
})(LogoSchema = exports.LogoSchema || (exports.LogoSchema = {}));
